import { useRef, useState } from 'react'

import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { RECEIPT_STATE, SUCURSAL_ORIGEN } from 'Constants'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const ExportPaymentOrders = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()
  const formikRef = useRef(null)

  const handleSubmit = () => {
    if (formikRef.current) formikRef.current.submitForm()
  }

  const today = new Date()

  const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const fields = (setFieldValue) => [
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Origen"
          name="origen"
          defaultValue={{ id: 1, label: 'ECO' }}
          options={SUCURSAL_ORIGEN}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('origen', value?.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha desde',
      format: 'dd-MM-yyyy',
      name: 'fecha_inicial',
      value: today,
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha hasta',
      format: 'dd-MM-yyyy',
      name: 'fecha_final',
      value: today,
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Estado"
          name="estado"
          defaultValue={RECEIPT_STATE[0]}
          options={RECEIPT_STATE}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('estado', value?.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
  ]

  const onSubmit = async (values) => {
    setLoading(true)

    const body = {
      origen: values.origen,
      fecha_inicial: formatDate(values.fecha_inicial),
      fecha_final: formatDate(values.fecha_final),
      estado: values.estado,
    }

    await interfaces.salesPaymentOrders
      .exportToExcel(body)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('Órdenes de pago exportadas!', {
          variant: 'success',
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal!', {
          variant: 'error',
        })
      })

    setLoading(false)
  }

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Exportar"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
        />
      }
      children={
        <Formik
          innerRef={formikRef}
          initialValues={{
            origen: 1,
            fecha_inicial: today,
            fecha_final: today,
            estado: 1,
          }}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ setFieldValue }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue)}
                spacing={2}
                setFieldValue={setFieldValue}
              />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default ExportPaymentOrders
